var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtendSubscriptionImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37667 5.37521L26.8775 5.3752L26.8775 17.306L25.3569 17.3129L25.463 8.55792L25.4671 8.45346C25.468 7.68009 24.8414 7.05231 24.0681 7.0514L5.37668 7.04405L5.37667 5.37521Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79037 7.46308L24.2915 7.46306L24.2916 18.6247L2.7904 18.6247L2.79037 7.46308Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7924 9.21616C20.781 10.0464 21.5127 10.7974 22.374 10.8078L22.3739 15.2239C21.4668 15.2125 20.7159 15.9442 20.7055 16.9334L6.40085 16.9334C6.41226 16.0262 5.68036 15.2752 4.81933 15.2648L4.81928 10.8487C5.72991 10.859 6.48138 10.1277 6.49176 9.21614L20.7924 9.21616Z",
    fill: "#87CC71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5588 10.2726C12.1209 8.59896 14.7434 8.50868 16.417 10.0708C18.0906 11.6326 18.1808 14.2554 16.6188 15.9289C15.0569 17.6025 12.4341 17.6928 10.7606 16.1307C9.08704 14.5687 8.99669 11.9461 10.5588 10.2726Z",
    fill: "#427D2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2778 13.1054L14.1668 13.5682L13.3954 13.5682C13.4951 13.8838 13.7127 14.0415 14.0455 14.0415C14.4113 14.0415 14.7537 13.9236 15.0718 13.6879L15.0718 14.6344C14.8074 14.8147 14.4885 14.9048 14.1149 14.9048C13.5107 14.9048 13.0635 14.767 12.7739 14.4914C12.4854 14.2157 12.3085 13.908 12.2435 13.5682L11.7841 13.5682L11.9046 13.1053L12.1854 13.1053C12.1819 13.0802 12.1802 13.0352 12.1802 12.971C12.1802 12.9034 12.182 12.8549 12.1854 12.8246L11.8465 12.8245L11.967 12.3617L12.2435 12.3617C12.4636 11.4914 13.0687 11.0563 14.0576 11.0563C14.3809 11.0563 14.7086 11.143 15.0406 11.3164L14.8117 12.2369C14.5812 12.0254 14.3402 11.9196 14.0897 11.9196C13.7612 11.9196 13.5384 12.067 13.4232 12.3616L14.3402 12.3616L14.2293 12.8245L13.3348 12.8245C13.3313 12.8583 13.3296 12.9069 13.3296 12.971L13.3296 13.1054L14.2778 13.1054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendSubscriptionImage);
export default __webpack_public_path__ + "static/media/extendSubscriptionImage.8ee507a8e324fd08024321a161a69713.svg";
export { ForwardRef as ReactComponent };